export interface ApiPrayer {
    id: number,
    audio_url: string,
    image_url: string,
    title: string,
    description: string,
    label_desc: string,
    shareable_quote: string
}

export const isApiPrayer = (obj: any): obj is ApiPrayer => {
    return typeof obj === 'object' &&
        obj.hasOwnProperty('id') &&
        obj.hasOwnProperty('title') &&
        obj.hasOwnProperty('description') &&
        obj.hasOwnProperty('audio_url') &&
        obj.hasOwnProperty('image_url') &&
        obj.hasOwnProperty('shareable_quote');
};